import React from "react"
import { Table } from "react-bootstrap"
import { formatCurrency } from "../../lib/utils"
import CaptionTable from "../fragments/CaptionTable"

export default function ItemSummary({ purchaseCost, sellingCost, otherCosts, balance, margin, isLarge }) {

  const titleBalance = 'Balance = Amount - (T. purchase cost + T. other costs)',
  titleMargin = 'Margin = T. selling price - (T. purchase cost + T. other costs)'

  return (
    <Table striped condensed hover responsive>

      <CaptionTable text='Summary' />

      <tbody>
        <tr>
          <th>{ `${ isLarge ? 'Total' : 'T.'} purchase cost` }</th>
          <th>{ `${ isLarge ? 'Total' : 'T.'} selling price` }</th>
          <th>{ `${ isLarge ? 'Total' : 'T.'} other costs` }</th>

          { balance !== null && <th className="hot-color"
            title={ titleBalance }>Balance</th> }

          <th className="green" title={ titleMargin }>Margin</th>
        </tr>

        <tr>
          <td>{ formatCurrency(purchaseCost) }</td>
          <td>{ formatCurrency(sellingCost) }</td>
          <td>{ formatCurrency(otherCosts) }</td>

          { balance !== null && <td className="hot-color" 
            title={ titleBalance }>{ formatCurrency(balance) }</td> }

          <td className="green" title={ titleMargin }>{ formatCurrency(margin) }</td>
        </tr>
      </tbody>
    </Table>
  )
}



// WEBPACK FOOTER //
// ./src/components/Financiers/ItemSummary.js